import { Colors } from '@fourthwall/components';
import styled from 'styled-components';
export const Container = styled.div `
  background-color: color-mix(in srgb, ${Colors.G100} 40%, transparent);
  color: ${Colors.G500};
  padding: 12px 16px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  font-size: 16px;
  font-weight: 600;
  line-height: 150%;
`;
